<script>
import Layout from "../../layouts/main";
import OrdersTab from "@/router/views/orders/ordersTab";
// import InvoicesTab from "@/router/views/invoices/invoicesList"
// import ReservationTab from "@/router/views/orders/cartsTab"
// import OrdersApi from "@/services/orders-api";
// import InvoicesApi from "@/services/invoices-api";
// import BackOrdersApi from "@/services/backOrders-api";
// import {Priviliges} from "../../../privileges";

/**
 * Orders-list component
 */
export default {

computed: {
    role() {
      return this.$cookies.get('userr');
    },
  },

  watch: {
        role: function() {
            this.isCustomer = this.role == 0;
        },
    },

  mounted(){
   
      
      this.isCustomer = this.role == 0;
      //this.countOrders()
      
  },

  components: {Layout,OrdersTab/*,InvoicesTab,ReservationTab*/ },
  data() {
    return { 
        backOrdersCount:0,
        ordersCount:0,
        invoicesCount:0,
        privileges:"", 
        hasOrdersListAccess:false,
        hasBackOrdersListAccess:false,
        hasInvoicesListAccess:false,
        isAdmin:false,
        isCustomer:false,
        hasCatalogAccess:false,
    };
  }, 

    methods: {
        // countBackOrders(){
        //     BackOrdersApi.getBackOrdersCount().then(
        //         (result)=>{
        //             if(result){
        //                 this.backOrdersCount=result
        //             }else{
        //                 this.backOrdersCount=0
        //             }
                    
        //         }
        //     )
        // },
        
        // countOrders(){
        //     OrdersApi.getOrdersCount(null).then(
        //         (result)=>{
        //             if(result){
        //                 this.ordersCount=result
        //             }else{
        //                 this.ordersCount=0

        //             }
        //         }
        //     )
        // },

        // countInvoices(){
        //     InvoicesApi.getInvoicesCount(null).then(
        //         (result)=>{
        //             if(result){
        //                 this.invoicesCount=result
        //             }else{
        //                 this.invoicesCount=0
        //             }
        //         }
        //     )
        // },
    }       
    }

</script>
<template>
<Layout>

    <!-- ---------- -->
    <!-- MAIN TITLE -->
    <!-- <div class="row p-0 mt-4 p-lg-4  d-print-none"  >
      
      <div class="col-12">
          <h2 class="text-dark font-weight-bold text-center text-lg-left">Suivi des commandes</h2>
          <h5  class="text-secondary text-center text-lg-left">{{this.ordersCount}}  &nbsp;{{$t('ordersMenu.title')}}</h5>
      </div>
      
 
  </div> -->
  <!-- MAIN TITLE -->
  <!-- ----------- -->

  <div class="row m-0 mt-4 m-lg-4 p-4 bg-white" style="border: 1px solid rgb(236, 237, 240);box-shadow: rgb(0 0 0 / 8%) 0px 2px 6px 0px;border-radius: 7px;">
        <div class="col-lg-12">
        
                

                <b-tabs fill nav-class="nav-tabs-custom" content-class="p-0 text-muted" align="center" active-nav-item-class="font-weight-bold text-uppercase ">

                    <!-- <b-tab v-if="isCustomer || isAdmin || hasBackOrdersListAccess"   lazy>
                    <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="fas fa-bookmark font-size-16"></i>
                    </span>
                    <i class="d-none d-sm-inline-block fas fa-bookmark font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">{{$t('cartTab.title')}}</span>
                    </template>
                    <ReservationTab class="mt-4"/>
                </b-tab> -->

                <!-- v-if="isCustomer || isAdmin || hasOrdersListAccess || hasCatalogAccess" -->

                <b-tab  active lazy>
                    <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="far fa-file-alt font-size-16"></i>
                    </span>
                    <i class="d-none d-sm-inline-block far fa-file-alt font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">{{$t('ordersMenu.title')}}</span>
                    </template>
                    <OrdersTab :propShowDrafts="false"/>
                </b-tab>

                <b-tab v-if="!isCustomer" lazy>
                    <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="far fa-file  font-size-16"></i>
                    </span>
                    <i class="d-none d-sm-inline-block far fa-file  font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">Paniers abandonnés</span>
                    </template>
                    <OrdersTab :propShowDrafts="true"/>
                </b-tab>

                <!-- <b-tab v-if="isCustomer || isAdmin || hasInvoicesListAccess" lazy>
                    <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="fas fa-file-invoice-dollar font-size-16"></i>
                    </span>
                    <i class="d-none d-sm-inline-block fas fa-truck-loading font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">Bons de Livraisons</span>
                    </template>
                    <InvoicesTab class="mt-4"/>
                </b-tab> -->
                </b-tabs>
            </div>
        
    </div>
</Layout>
</template>